if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.containsMultipleKeywords
) {
  Object.defineProperty(String.prototype, 'containsMultipleKeywords', {
    value(pattern = []) {
      let occurence = 0;
      pattern.forEach( (word) => {
        occurence += this.includes(word);
      });
      return occurence > 1;
    }
  });
}